import audio1 from  'assets/sounds/no/diktat/norming/01.mp3';
import audio2 from  'assets/sounds/no/diktat/norming/02.mp3';
import audio3 from  'assets/sounds/no/diktat/norming/03.mp3';
import audio4 from  'assets/sounds/no/diktat/norming/04.mp3';
import audio5 from  'assets/sounds/no/diktat/norming/05.mp3';
import audio6 from  'assets/sounds/no/diktat/norming/06.mp3';
import audio7 from  'assets/sounds/no/diktat/norming/07.mp3';
import audio8 from  'assets/sounds/no/diktat/norming/08.mp3';
import audio10 from 'assets/sounds/no/diktat/norming/10.mp3';
import audio11 from 'assets/sounds/no/diktat/norming/11.mp3';
import audio12 from 'assets/sounds/no/diktat/norming/12.mp3';
import audio13 from 'assets/sounds/no/diktat/norming/13.mp3';
import audio14 from 'assets/sounds/no/diktat/norming/14.mp3';
import audio15 from 'assets/sounds/no/diktat/norming/15.mp3';
import audio16 from 'assets/sounds/no/diktat/norming/16.mp3';
import audio17 from 'assets/sounds/no/diktat/norming/17.mp3';
import audio18 from 'assets/sounds/no/diktat/norming/18.mp3';
import audio19 from 'assets/sounds/no/diktat/norming/19.mp3';
import audio20 from 'assets/sounds/no/diktat/norming/20.mp3';
import audio21 from 'assets/sounds/no/diktat/norming/21.mp3';
import audio22 from 'assets/sounds/no/diktat/norming/22.mp3';
import audio23 from 'assets/sounds/no/diktat/norming/23.mp3';
import audio24 from 'assets/sounds/no/diktat/norming/24.mp3';
import audio25 from 'assets/sounds/no/diktat/norming/25.mp3';
import audio26 from 'assets/sounds/no/diktat/norming/26.mp3';
import audio27 from 'assets/sounds/no/diktat/norming/27.mp3';
import audio28 from 'assets/sounds/no/diktat/norming/28.mp3';
import audio29 from 'assets/sounds/no/diktat/norming/29.mp3';
import audio30 from 'assets/sounds/no/diktat/norming/30.mp3';

const audioFiles = {
	1: audio1,
	2: audio2,
	3: audio3,
	4: audio4,
	5: audio5,
	6: audio6,
	7: audio7,
	8: audio8,
	9: audio10,
	10: audio11,
	11: audio12,
	12: audio13,
	13: audio14,
	14: audio15,
	15: audio16,
	16: audio17,
	17: audio18,
	18: audio19,
	19: audio20,
	20: audio21,
	21: audio22,
	22: audio23,
	23: audio24,
	24: audio25,
	25: audio26,
	26: audio27,
	27: audio28,
	28: audio29,
	29: audio30,
};

export default audioFiles;
